import { useState } from 'react';
import {axiosInstance} from "../services/axiosConfig";
import { SSO_URL, STRIDE_AUTH_URL } from "../utility/constants";

const useFetchSsoTokenLearning = () => {
    const [response, setResponse] = useState( null );
    const [error, setError] = useState( null );
    const [isLoading, setIsLoading] = useState( false );

    const FetchSsoTokenLearning = async ( clientId ) => {
        setIsLoading( true );

        const requestBody = {
            client_id: clientId,
            type : 'lms',
        }

        try {
            const res = await axiosInstance.post( STRIDE_AUTH_URL + SSO_URL, requestBody );
            setResponse( res );
            setError( null );
        } catch ( err ) {
            setError( err );
            console.log( err );
        } finally {
            setIsLoading( false );
        }
    };

    return { response, error, isLoading, FetchSsoTokenLearning };
};

export default useFetchSsoTokenLearning;